import { CSSObject } from "@emotion/react";
import { typographyStyles } from "@newsela/angelou";

export const levelContainerCssAvg: CSSObject = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  textWrap: "nowrap",
};

export const commonLevelCss: CSSObject = {
  ...typographyStyles.heading5Obj,
  margin: 0,
};

export const boldDataCss: CSSObject = {
  ...commonLevelCss,
  fontWeight: "700",
};
